import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { buildLearningTopicPath, getLearningInvitationRows } from '../../lib/educationContent';

const defaultLabel = (row) => `Learn about ${row.context_label || row.topic.title}`;

const LearningInvitationLink = ({ topics = [], matterId, questionKey }) => {
  const invitationRows = getLearningInvitationRows(topics);

  if (!invitationRows.length) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {invitationRows.map((row) => (
        <Link
          key={`${row.question_key}-${row.topic.id}`}
          to={buildLearningTopicPath({ slug: row.topic.slug, matterId, questionKey })}
          className="inline-flex items-center rounded-md border border-blue-100 bg-blue-50 px-3 py-1.5 text-xs font-bold uppercase tracking-widest text-blue-700 transition-colors hover:border-blue-200 hover:bg-blue-100"
        >
          <SafeIcon icon={FiIcons.FiBookOpen} className="mr-1.5 h-3.5 w-3.5" />
          {row.help_cta_label || defaultLabel(row)}
          <SafeIcon icon={FiIcons.FiArrowRight} className="ml-1.5 h-3.5 w-3.5" />
        </Link>
      ))}
    </div>
  );
};

export default LearningInvitationLink;
